var map = {
	"./business-model.js": 488,
	"./game-view.js": 13,
	"./introduction.js": 489,
	"./questionnaire.js": 490,
	"./reconnect.js": 491,
	"./sell.js": 492,
	"./session-join.js": 493
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;



//////////////////
// WEBPACK FOOTER
// ./app/js/components/game/views nonrecursive \.js$
// module id = 479
// module chunks = 2